import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { normalizeUploadedImageUrl } from './uploadImage';

export const getAdminEcosystemGroups = async (params = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ECOSYSTEM_GROUPS.GET_ALL, {
        params: { languageCode: 'vi', ...params },
    });
    return response.data;
};

// Read-only endpoint for public pages and the website navbar.
// Do not use the admin collection endpoint here because public visitors do not
// have an admin session/token.
export const getEcosystemGroupsByLanguage = async (languageCode = 'vi') => {
    const response = await axiosInstance.get(`/ecosystem-groups/${languageCode}`);
    const rawData = response.data;
    // Normalize ảnh từ backend: gắn ASSET_BASE_URL vào những URL dạng /upload/...
    const items = Array.isArray(rawData?.data) ? rawData.data
        : Array.isArray(rawData) ? rawData
        : [];
    const normalized = items.map(group => ({
        ...group,
        imageUrl: normalizeUploadedImageUrl(group.imageUrl || ''),
        services: (group.services || group.EcosystemServices || []).map(s => ({
            ...s,
            imageUrl: normalizeUploadedImageUrl(s.imageUrl || ''),
        })),
        EcosystemServices: (group.EcosystemServices || group.services || []).map(s => ({
            ...s,
            imageUrl: normalizeUploadedImageUrl(s.imageUrl || ''),
        })),
        products: (group.products || []).map(p => ({
            ...p,
            image: normalizeUploadedImageUrl(p.image || p.imageUrl || ''),
        })),
    }));
    // Trả về theo cùng cấu trúc với raw response
    if (Array.isArray(rawData?.data)) return { ...rawData, data: normalized };
    return normalized;
};

export const getAdminEcosystemGroupById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.ECOSYSTEM_GROUPS.GET_BY_ID(id));
    return response.data;
};

export const createEcosystemGroup = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.ECOSYSTEM_GROUPS.CREATE, data);
    return response.data;
};

export const updateEcosystemGroup = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.ECOSYSTEM_GROUPS.UPDATE(id), data);
    return response.data;
};

export const deleteEcosystemGroup = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.ECOSYSTEM_GROUPS.DELETE(id));
    return response.data;
};
